import { secondsInMilliseconds } from '../utils'
import { ITimer } from './interfaces'
import { DEFAULT_TIMER_INTERVAL } from './constants'

class PsmTimer implements ITimer {
  interval: number
  callback: Function
  timer: number
  isTimerRunning: boolean

  constructor(timerCallback: Function, timerInterval: number = DEFAULT_TIMER_INTERVAL) {
    this.callback = timerCallback
    this.setIntervalInMilliseconds(timerInterval || DEFAULT_TIMER_INTERVAL)
    this.isTimerRunning = false
  }

  setIntervalInMilliseconds = function(intervalSeconds: number): void {
    this.interval = secondsInMilliseconds(intervalSeconds)
  }

  start(): number {
    this.timer = setInterval(this.callback, this.interval)
    this.isTimerRunning = true
    return this.timer
  }

  stop(): number {
    clearInterval(this.timer)
    this.isTimerRunning = false
    this.timer = null
    return this.timer
  }

  reset(): number {
    this.stop()
    return this.start()
  }

  updateInterval(newInterval: number): number {
    this.setIntervalInMilliseconds(newInterval)
    return this.reset()
  }
}

export default PsmTimer
